import { NavLink, useHistory } from 'react-router-dom';
import logo from '../../../assets/static/icons/logo.png';
import iTrustLogo from "../../../assets/static/images/itrust-logo.png";
import { AutoComplete } from '../../others';
import { openInNewTab, humanize, getShortName, defaultImage, capitalizeInitials } from '../../HelperFunctions';
import { connect } from 'react-redux';
import * as $ from 'jquery'
import Notification from '../../../../containers/authorised/notification/Notification';
import { currentUserEditing } from '../../../redux/actions/authActions';
import CurrencyIconsView from '../../others/CurrencyIconsView';

function Topbar(props) {
  const { headerMenu, userType, storeSelectionComponent, currentUser, organisation, store, dispatch, activeTourType, dateFormatType, syncBillingCurrency, storeSpecificPatients, currentStoreId, handleLogout } = props
  const history = useHistory()

  const searchType = (userType, dateFormatType, storeSpecificPatients, currentStoreId) => {
    switch (userType) {
      case 'Staff': return (
        <AutoComplete
          valueField="id"
          klass="Patient"
          textField="name"
          fieldName="patient"
          dropdownClasses="mt-4"
          wrapperclassName="search-bar py-1"
          onSelect={(id) => history.push(`/patients/${id}`)}
          placeholder={`Search by name, DOB(${dateFormatType}) or phone`}
          additionalFilters={{ store_id: (storeSpecificPatients && currentStoreId) ? currentStoreId : '' }}
        />
      )
      case 'User': return (
        <AutoComplete
          textField="name"
          valueField="id"
          klass="Organisation"
          fieldName="organisation"
          wrapperclassName="search-bar py-1"
          onSelect={(id) => openInNewTab(`/organisations/${id}`)}
        />
      )
      default:
    }
  }

  return (
    <header className="app-header bg-white w-100 position-fixed border-bottom">
      <div className="d-flex p-5">
        <div className="org-logo-div text-left">
          {process.env.REACT_APP_SUITE_NAME === "OWNER-SUITE" ?
            <img src={logo} alt="logo" className="img-fluid" style={{ height: "3rem" }} /> :
            userType !== "Patient" ?
              <NavLink to="/"><img src={iTrustLogo} alt="iTrust" style={{ maxWidth: "10rem" }} /></NavLink> :
              <NavLink to={`/patients/${currentUser.id}/overview`}>
                {organisation.logo_attributes ? <img src={defaultImage(organisation.logo_attributes)} alt="logo" className="img-fluid" style={{ height: "3rem" }} /> : <p className="store-logo-text py-4 mx-auto"><span className="bg-white p-4">{organisation.name}</span></p>}
              </NavLink>
          }
        </div>
        {/* <div className="org-operation-div-d"> */}
        <div className="d-flex justify-content-end align-items-center w-100">
          {(userType === "Staff" || userType === "Patient") &&
            storeSelectionComponent
          }

          <div className="row org-logo-div px-lg-9 px-2">
            <div className="col-12 px-0">
              {searchType(userType, dateFormatType, storeSpecificPatients, currentStoreId)}
            </div>
          </div>

          <div className={`profile d-flex flex-row align-items-center justify-content-end`}>
            {currentUser.type !== "Patient" && <Notification />}
            <div className={`px-3 py-2 pointer organisation-menu ${activeTourType === 'activate_account' && 'showDropdown'}`}>
              <a className='d-flex align-items-center' data-toggle="dropdown">
                <i className="las la-angle-down mr-3"></i>
                {getShortName(currentUser, 'profile-pic', 'profile-pic font-size-18')}
              </a>
              <div className="dropdown-menu border-0 shadow">
                {headerMenu.map(function (item) {
                  if (item.title != 'Contact' && item.title != 'Preferences') {
                    return (
                      <NavLink key={item.path} to={item.path} className={`dropdown-item py-4 ${item.title === 'Your Billing' && 'activate-account-step-1'}`}>
                        {item.title == 'Manage Organization' ?
                          <i className={`la ${item.icon} pr-2`} /> :
                          <>
                            {syncBillingCurrency ?
                              <CurrencyIconsView className="pr-2" /> :
                              <i className={`la ${item.icon} pr-2`} />
                            }
                          </>
                        }
                        {item.title}
                      </NavLink>)
                  }
                  else if (item.title === 'Preferences') {
                    return (
                      <button className="dropdown-item py-4" onClick={() => { dispatch(currentUserEditing({ preferencesEdit: true })); $('#preferences-modal').modal('show') }}>
                        <i className={`la ${item.icon} pr-2`} />
                        {item.title}
                      </button>)
                  }
                })
                }
                {currentUser.type !== "Patient" &&
                  <a className="dropdown-item py-4" target="_blank" rel="noopener noreferrer" href="https://www.manula.com/manuals/itrust/itrust-optometry-cloud-ehr/2/en/topic/itrust-optometry-ehr-user-manual"><i className="la la-external-link-alt pr-2 pt-3" />User Manual</a>
                }
                <button className="dropdown-item py-4" onClick={() => handleLogout()}><i className="la la-sign-out pr-2 pt-3" />Logout</button>
              </div>
            </div>
            <div className="px-2 text-left">
              <span className="profile-details-section-designation text-nowrap">{currentUser.name}<br />
                <i className="text-nowrap">{capitalizeInitials(humanize(currentUser.role))}</i></span>
            </div>
          </div>
        </div>
        {/* </div> */}
      </div>
    </header>
  )
}

const mapStateToProps = state => {
  const { store, auth, organisation, currentStore, onBoarding } = state
  return {
    stores: store.stores,
    store: currentStore && currentStore.store,
    currentUser: auth.user,
    organisation: organisation.organisation,
    activeTourType: onBoarding?.activeTourType,
    dateFormatType: organisation.organisation.preferences?.date_format,
    syncBillingCurrency: organisation.organisation.subscription_details?.pricing?.sync_billing_currency_with_app,
    storeSpecificPatients: organisation.organisation.preferences?.store_specific_patients,
    currentStoreId: currentStore?.store?.id,
  }
}
export default connect(mapStateToProps)(Topbar);